import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import InlineCode from '@primer/gatsby-theme-doctocat/src/components/inline-code';
import { PropTableValues } from '../../src/components';
import { Label } from '@primer/react';
import { Link } from 'gatsby';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {TextInput} from '@primer/react-brand'
`}</code></pre>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<TextInput aria-label="Demo TextInput" />
`}</code></pre>
    <h3>{`Variants`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Container
  sx={{
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: 'repeat(2,minmax(40px,auto))',
    gridGap: 4,
  }}
>
  <FormControl fullWidth>
    <FormControl.Label>Text (default)</FormControl.Label>
    <TextInput type="text" placeholder="alphanumeric" />
  </FormControl>
  <FormControl fullWidth>
    <FormControl.Label>Number</FormControl.Label>
    <TextInput type="number" placeholder="123" />
  </FormControl>
  <FormControl fullWidth>
    <FormControl.Label>Email</FormControl.Label>
    <TextInput
      type="email"
      autoComplete="email"
      placeholder="mona@github.com"
    />
  </FormControl>
  <FormControl fullWidth>
    <FormControl.Label>Password</FormControl.Label>
    <TextInput
      type="password"
      autoComplete="current-password"
      value="monalisa"
    />
  </FormControl>
  <FormControl fullWidth>
    <FormControl.Label>Month</FormControl.Label>
    <TextInput type="month" />
  </FormControl>
  <FormControl fullWidth>
    <FormControl.Label>Telephone</FormControl.Label>
    <TextInput type="tel" autoComplete="tel" />
  </FormControl>
  <FormControl fullWidth>
    <FormControl.Label>Time</FormControl.Label>
    <TextInput type="time" />
  </FormControl>
  <FormControl fullWidth>
    <FormControl.Label>Date</FormControl.Label>
    <TextInput type="date" />
  </FormControl>
  <FormControl fullWidth>
    <FormControl.Label>Date (local)</FormControl.Label>
    <TextInput type="datetime-local" />
  </FormControl>
  <FormControl fullWidth>
    <FormControl.Label>URL</FormControl.Label>
    <TextInput type="url" autoComplete="url" value="https://github.com" />
  </FormControl>
</Container>
`}</code></pre>
    <h3>{`Use with `}<inlineCode parentName="h3">{`FormControl`}</inlineCode></h3>
    <p>{`Use `}<inlineCode parentName="p">{`TextInput`}</inlineCode>{` alongside `}<inlineCode parentName="p">{`FormControl`}</inlineCode>{` to ensure the control always has a corresponding form label.`}</p>
    <p><a parentName="p" {...{
        "href": ".FormControl.mdx"
      }}>{`See FormControl for additional usage examples.`}</a></p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<FormControl>
  <FormControl.Label>First name</FormControl.Label>
  <TextInput autoComplete="given-name" />
</FormControl>
`}</code></pre>
    <h3>{`Placeholder`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<FormControl fullWidth>
  <FormControl.Label>First name</FormControl.Label>
  <TextInput placeholder="Mona" autoComplete="given-name" />
</FormControl>
`}</code></pre>
    <h3>{`Autocomplete`}</h3>
    <p>{`The `}<inlineCode parentName="p">{`autoComplete`}</inlineCode>{` prop should be provided wherever possible to allow browsers to autofill the input field. See MDN for `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete"
      }}>{`a complete list of autocomplete values`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<FormControl fullWidth>
  <FormControl.Label>First name</FormControl.Label>
  <TextInput autoComplete="given-name" />
</FormControl>
`}</code></pre>
    <h3>{`Validation`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Container sx={{display: 'inline-grid', gap: 3}}>
  <FormControl validationStatus="error">
    <FormControl.Label>Error</FormControl.Label>
    <TextInput />
    <FormControl.Validation>This is an error message</FormControl.Validation>
  </FormControl>
  <FormControl validationStatus="success">
    <FormControl.Label>Success</FormControl.Label>
    <TextInput />
    <FormControl.Validation>This is a success message</FormControl.Validation>
  </FormControl>
</Container>
`}</code></pre>
    <h3>{`Full width`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<TextInput fullWidth aria-label="Full width TextInput" />
`}</code></pre>
    <h3>{`Sizes`}</h3>
    <p><inlineCode parentName="p">{`FormControl`}</inlineCode>{` can appear in `}<inlineCode parentName="p">{`medium`}</inlineCode>{` (default) and `}<inlineCode parentName="p">{`large`}</inlineCode>{` dimensions using the `}<inlineCode parentName="p">{`size`}</inlineCode>{` prop.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Container sx={{display: 'inline-grid', gap: 3}}>
  <TextInput size="medium" aria-label="Medium TextInput" />

  <TextInput size="large" aria-label="Large TextInput" />
</Container>
`}</code></pre>
    <h3>{`Required`}</h3>
    <p>{`Pass the `}<inlineCode parentName="p">{`required`}</inlineCode>{` prop to ensure that the input field must be filled out before submitting the form.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<TextInput required aria-label="Required TextInput" />
`}</code></pre>
    <h3>{`Using `}<inlineCode parentName="h3">{`refs`}</inlineCode></h3>
    <p><inlineCode parentName="p">{`TextInput`}</inlineCode>{` inputs can be used in `}<a parentName="p" {...{
        "href": "https://reactjs.org/docs/uncontrolled-components.html"
      }}>{`uncontrolled mode`}</a>{` by forwarding a `}<inlineCode parentName="p">{`ref`}</inlineCode>{` to the underlying element.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const App = () => {
  const inputRef = React.useRef(null)

  const handleSubmit = (e) => {
    e.preventDefault()
    if (!inputRef.current.value) {
      alert(\`Enter a value and try again.\`)
      return
    }

    alert(\`Name: \${inputRef.current.value}\`)
  }

  return (
    <form onSubmit={handleSubmit}>
      <Container
        sx={{
          display: 'grid',
          gap: 'var(--base-size-16)',
          maxWidth: 400,
          marginX: 'auto',
        }}
      >
        <FormControl fullWidth>
          <FormControl.Label>Name</FormControl.Label>
          <TextInput ref={inputRef} />
        </FormControl>
        <Button type="submit" variant="primary">
          Submit
        </Button>
      </Container>
    </form>
  )
}

render(App)
`}</code></pre>
    <h2>{`Component props`}</h2>
    <p><inlineCode parentName="p">{`TextInput`}</inlineCode>{` provides a React alternative to the native HTML `}<inlineCode parentName="p">{`<input>`}</inlineCode>{` in single-line mode.`}</p>
    <p>{`The component API supports all standard HTML attribute props, while providing some additional behaviour as described below.`}</p>
    <h3>{`TextInput `}<Label mdxType="Label">{`Required`}</Label></h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`children`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={['TextInput.Option', 'TextInput.OptGroup']} addLineBreaks mdxType="PropTableValues" />{`,`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Valid child nodes`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`className`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom class`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets a custom id`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`fullWidth`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Stretches elements visually to the edges of its parent container.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`ref`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.RefObject`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Forward a Ref to the underlying DOM node`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`size`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={['medium', 'large']} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Visual dimensions for the input`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`type`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={['text', 'number', 'email', 'password', 'search', 'tel', 'url', 'date', 'time', 'datetime-local']} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`text`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Alternative text inputs`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`validationStatus`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><PropTableValues values={['error', 'success']} addLineBreaks mdxType="PropTableValues" /></td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Applies visual and semantic state to the underlying elements`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Additional props can be passed to the `}<inlineCode parentName="p">{`<input>`}</inlineCode>{` element. `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input"
      }}>{`See MDN for a list of props`}</a>{` accepted by the `}<inlineCode parentName="p">{`<input>`}</inlineCode>{` element.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul">
        <Link to="/components/FormControl" mdxType="Link">FormControl</Link>
      </li>
      <li parentName="ul">
        <Link to="/components/Select" mdxType="Link">Select</Link>
      </li>
      <li parentName="ul">
        <Link to="/components/TextInput" mdxType="Link">TextInput</Link>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      